import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";
import { superAuth, CAPTCHA } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { Button, Input } from "../../components/ui";

// เข้าสู่ระบบทีมงาน (super_user ของ PaymentBroker)
export default function SuperLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setProfile, toast } = useApp();
  const { tx } = useI18n();
  const [form, setForm] = useState({ email: "", password: "" });
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!form.email || !form.password) return setError(tx("กรุณากรอกอีเมลและรหัสผ่าน", "Please fill in email and password"));
    setLoading(true);
    try {
      const profile = await superAuth.login({ ...form, captchaToken });
      setProfile(profile);
      toast(tx("เข้าสู่ระบบสำเร็จ", "Logged in"), "success");
      navigate(location.state?.from || "/su", { replace: true });
    } catch (err) {
      setError(err.message);
      setCaptchaToken("");
      setCaptchaKey(Date.now());
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 6 }}>{tx("ทีมงานเจ้าของระบบ", "Platform team")}</h1>
      <p className="u-muted u-mb-16">
        {tx("เข้าสู่ระบบด้วยบัญชี super_user ของ PaymentBroker", "Sign in with your PaymentBroker super_user account")}
      </p>
      <form onSubmit={submit}>
        <Input label={tx("อีเมล", "Email")} type="email" value={form.email} autoComplete="username" onChange={(event) => setForm({ ...form, email: event.target.value })} />
        <Input label={tx("รหัสผ่าน", "Password")} type="password" value={form.password} autoComplete="current-password" onChange={(event) => setForm({ ...form, password: event.target.value })} />
        {CAPTCHA.siteKey ? (
          <div className="u-mb-16">
            <Turnstile key={captchaKey} sitekey={CAPTCHA.siteKey} onVerify={setCaptchaToken} onExpire={() => setCaptchaToken("")} onError={() => setCaptchaToken("")} />
          </div>
        ) : null}
        {error ? <div className="field-error u-mb-8">{error}</div> : null}
        <Button type="submit" variant="primary" block disabled={loading}>
          {loading ? tx("กำลังเข้าสู่ระบบ...", "Signing in...") : tx("เข้าสู่ระบบ", "Log in")}
        </Button>
      </form>
      <div className="u-fs-12 u-muted u-mt-16">
        {tx(
          "หมายเหตุ: เข้าสู่ระบบที่นี่จะทำให้ session ของบัญชีเดียวกันใน PaymentBroker หลุด (ระบบเก็บ token ล่าสุดไว้ตัวเดียว)",
          "Note: signing in here ends the same account's PaymentBroker session (only the latest token is kept)."
        )}
      </div>
    </>
  );
}
